import axios from "axios";
import {
  ACCLAIM_GIFT_ERROR,
  ACCLAIM_GIFT_REQUEST,
  ACCLAIM_GIFT_SUCCESS,
  ACTIVATE_SERVICE_WITH_CREDIT_CARD_ERROR,
  ACTIVATE_SERVICE_WITH_CREDIT_CARD_REQUEST,
  ACTIVATE_SERVICE_WITH_CREDIT_CARD_SUCCESS,
  ACTIVATE_SERVICE_WITH_CREDIT_ERROR,
  ACTIVATE_SERVICE_WITH_CREDIT_REQUEST,
  ACTIVATE_SERVICE_WITH_CREDIT_SUCCESS,
  ACTIVATE_SERVICE_WITH_CRYPTO_ERROR,
  ACTIVATE_SERVICE_WITH_CRYPTO_REQUEST,
  ACTIVATE_SERVICE_WITH_CRYPTO_SUCCESS,
  CANCEL_SUBSCRIPTION_ERROR,
  CANCEL_SUBSCRIPTION_REQUEST,
  CANCEL_SUBSCRIPTION_SUCCESS,
  CHARGE_CREDIT_WITH_CRYPTO_ERROR,
  CHARGE_CREDIT_WITH_CRYPTO_REQUEST,
  CHARGE_CREDIT_WITH_CRYPTO_SUCCESS,
  DISCOUNT_ERROR,
  DISCOUNT_REQUEST,
  DISCOUNT_SUCCESS,
  GET_FREE_PLAN_ERROR,
  GET_FREE_PLAN_REQUEST,
  GET_FREE_PLAN_SUCCESS,
  GET_PRICING_PLANS_ERROR,
  GET_PRICING_PLANS_REQUEST,
  GET_PRICING_PLANS_SUCCESS,
  GET_REFERRAL_CODE_ERROR,
  GET_REFERRAL_CODE_REQUEST,
  GET_REFERRAL_CODE_SUCCESS,
  GET_REFERRAL_REWARD_ERROR,
  GET_REFERRAL_REWARD_REQUEST,
  GET_REFERRAL_REWARD_SUCCESS,
  GET_STRIPE_CHECKOUT_SESSION_ERROR,
  GET_STRIPE_CHECKOUT_SESSION_REQUEST,
  GET_STRIPE_CHECKOUT_SESSION_SUCCESS,
  GET_USER_SUBSCRIPTIONS_ERROR,
  GET_USER_SUBSCRIPTIONS_REQUEST,
  GET_USER_SUBSCRIPTIONS_SUCCESS,
  INCREASE_CREDIT_WITH_CARD_ERROR,
  INCREASE_CREDIT_WITH_CARD_REQUEST,
  INCREASE_CREDIT_WITH_CARD_SUCCESS,
  REDEEM_GIFT_ERROR,
  REDEEM_GIFT_REQUEST,
  REDEEM_GIFT_SUCCESS,
  REFUND_ERROR,
  REFUND_REQUEST,
  REFUND_SUCCESS,
  RENEW_ERROR,
  RENEW_REQUEST,
  RENEW_SUCCESS,
  SEND_CHAT_ERROR,
  SEND_CHAT_REQUEST,
  SEND_CHAT_SUCCESS,
  WITHDRAW_ERROR,
  WITHDRAW_REQUEST,
  WITHDRAW_SUCCESS,
} from "./consts";
import alert from "../../components/alerts/Alert";
import { getProfileData } from "../profile/actions";
import { axiosErrorHandler } from "../../utility/action-helper";
import { formatTelegramLog } from "../../utility/formatter-helper";

export const getCheckoutLink =
  (
    email,
    user,
    plan_mode,
    success_url,
    cancel_url,
    signal = null,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: GET_STRIPE_CHECKOUT_SESSION_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "get_stripe_checkout_session",
      plan_mode,
      success_url,
      cancel_url,
    };

    try {
      const res = await axios.post(url, requestPayload, { signal });
      const data = res.data;
      dispatch({
        type: GET_STRIPE_CHECKOUT_SESSION_SUCCESS,
        payload: data.checkout_session_url,
      });
    } catch (err) {
      if (axios.isCancel(err)) {
        dispatch({ type: "get-checkout-session-cancelled" });
      } else {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            getCheckoutLink(
              email,
              user,
              plan_mode,
              success_url,
              cancel_url,
              retryCount + 1,
            ),
          GET_STRIPE_CHECKOUT_SESSION_ERROR,
          user,
          email,
          formatTelegramLog("get_stripe_checkout_session", requestPayload, url),
          0,
          currentPath,
        );
      }
    }
  };

export const resetCheckoutLink = () => async (dispatch) => {
  dispatch({ type: "reset-checkout-link" });
};

export const getSubscriptions =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_USER_SUBSCRIPTIONS_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "get_user_subscriptions",
    };

    try {
      const res = await axios.post(url, requestPayload);
      const data = res.data;

      dispatch({
        type: GET_USER_SUBSCRIPTIONS_SUCCESS,
        payload: data,
      });
    } catch (err) {
      axiosErrorHandler(
        err,
        retryCount,
        dispatch,
        () => getSubscriptions(email, user, retryCount + 1),
        GET_USER_SUBSCRIPTIONS_ERROR,
        user,
        email,
        formatTelegramLog("get_user_subscriptions", requestPayload, url),
        0,
        currentPath,
      );
    }
  };

export const cancelSubscription =
  (
    email,
    user,
    plan_mode,
    endTime,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: CANCEL_SUBSCRIPTION_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";

    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "cancell_subscription",
      plan_mode,
    };

    try {
      const res = await axios.post(url, requestPayload);
      const data = res.data;
      dispatch({
        type: CANCEL_SUBSCRIPTION_SUCCESS,
        payload: data,
      });
      alert(
        null,
        `Subscription cancelled.\n You can still use your plan until ${endTime}`,
        "success",
        {
          cancel: "Ok",
        },
      );
      dispatch(getProfileData(email, user));
      // dispatch(getSubscriptions(email, user));
    } catch (err) {
      axiosErrorHandler(
        err,
        retryCount,
        dispatch,
        () => cancelSubscription(email, user, plan_mode, retryCount + 1),
        CANCEL_SUBSCRIPTION_ERROR,
        user,
        email,
        formatTelegramLog("cancell_subscription", requestPayload, url),
        0,
        currentPath,
      );
    }
  };

export const refund =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: REFUND_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "refund_request",
    };

    try {
      const res = await axios.post(url, requestPayload);
      const data = res.data;

      dispatch({
        type: REFUND_SUCCESS,
        payload: data.message,
      });
      dispatch(getProfileData(email, user));
      alert(
        // "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api",
        "",
        "Thank you for choosing our service. If you have not used it at all in the past 15 days, we will check our records and issue a full refund without any questions.\n We value your trust and honesty and we hope you are happy with your purchase.",
        "success",
        {
          cancel: "Close",
        },
      );
    } catch (err) {
      axiosErrorHandler(
        err,
        retryCount,
        dispatch,
        () => refund(email, user, retryCount + 1),
        REFUND_ERROR,
        user,
        email,
        formatTelegramLog("refund_request", requestPayload, url),
        0,
        currentPath,
      );
    }
  };

export const sendChat =
  (
    email,
    user,
    chat_text,
    plan_type,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: SEND_CHAT_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "send_cancellation_chat",
      chat_text,
      plan_type,
    };

    try {
      const res = await axios.post(url, requestPayload);
      const data = res.data;

      dispatch({
        type: SEND_CHAT_SUCCESS,
        payload: data.message,
      });
      dispatch(getProfileData(email, user));
    } catch (err) {
      axiosErrorHandler(
        err,
        retryCount,
        dispatch,
        () => sendChat(email, user, chat_text, retryCount + 1),
        SEND_CHAT_ERROR,
        user,
        email,
        formatTelegramLog("send_cancellation_chat", requestPayload, url),
        0,
        currentPath,
      );
    }
  };

export const renew =
  (
    email,
    user,
    plan_mode,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: RENEW_REQUEST, payload: plan_mode });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "renew_subscription",
      plan_mode,
    };

    try {
      const res = await axios.post(url, requestPayload);
      const data = res.data;
      dispatch({
        type: RENEW_SUCCESS,
        payload: data.message,
      });
      dispatch(getProfileData(email, user));
      alert(
        null,
        "Your subscription has been renewed successfully!",
        "success",
        {
          cancel: "Ok",
        },
      );
      // message.success("Your subscription has been renewed successfully!");
      // dispatch(getSubscriptions(email, user));
    } catch (err) {
      axiosErrorHandler(
        err,
        retryCount,
        dispatch,
        () => renew(email, user, plan_mode, retryCount + 1),
        RENEW_ERROR,
        user,
        email,
        formatTelegramLog("renew_subscription", requestPayload, url),
        0,
        currentPath,
      );
    }
  };

export const discount =
  (
    email,
    user,
    plan_mode,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: DISCOUNT_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "discount_for_continue",
      plan_mode,
    };

    try {
      const res = await axios.post(url, requestPayload);
      const data = res.data;
      dispatch({
        type: DISCOUNT_SUCCESS,
        payload: data.message,
      });
      dispatch(getProfileData(email, user));
    } catch (err) {
      axiosErrorHandler(
        err,
        retryCount,
        dispatch,
        () => discount(email, user, plan_mode, retryCount + 1),
        DISCOUNT_ERROR,
        user,
        email,
        formatTelegramLog("discount_for_continue", requestPayload, url),
        0,
        currentPath,
      );
    }
  };

export const redeemGift =
  (email, user, code, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: REDEEM_GIFT_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "redeem_gift_code",
      gift_code: code,
    };

    try {
      const res = await axios.post(url, requestPayload);
      const data = res.data;
      if (data.STATUS_CODE === 200) {
        dispatch({ type: REDEEM_GIFT_SUCCESS, payload: data.MESSAGE });
        dispatch(getProfileData(email, user));
      } else {
        dispatch({ type: REDEEM_GIFT_ERROR, payload: data.MESSAGE });
      }
    } catch (err) {
      axiosErrorHandler(
        err,
        retryCount,
        dispatch,
        () => redeemGift(email, user, code, retryCount + 1),
        REDEEM_GIFT_ERROR,
        user,
        email,
        formatTelegramLog("redeem_gift_code", requestPayload, url),
        0,
        currentPath,
      );
    }
  };

export const acclaimGift =
  (email, user, date, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: ACCLAIM_GIFT_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "acclaim_gift",
      createdDate: date,
    };

    try {
      const res = await axios.post(url, requestPayload);
      const data = res.data;
      if (data.Message === "The gift has been redeemed successfully!") {
        dispatch({ type: ACCLAIM_GIFT_SUCCESS, payload: data.Message });
      } else {
        dispatch({ type: ACCLAIM_GIFT_ERROR, payload: data.Message });
      }
    } catch (err) {
      axiosErrorHandler(
        err,
        retryCount,
        dispatch,
        () => acclaimGift(email, user, date, retryCount + 1),
        ACCLAIM_GIFT_ERROR,
        user,
        email,
        formatTelegramLog("acclaim_gift", requestPayload, url),
        0,
        currentPath,
      );
    }
  };

export const getFreePlan =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_FREE_PLAN_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "get_free_tier_stat",
    };

    await axios
      .post(url, requestPayload)
      .then((res) => {
        dispatch({ type: GET_FREE_PLAN_SUCCESS, payload: res?.data });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getFreePlan(email, user, retryCount + 1),
          GET_FREE_PLAN_ERROR,
          user,
          email,
          formatTelegramLog("get_free_tier_stat", requestPayload, url),
          0,
          currentPath,
        );
      });
  };

export const getReferralCode =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_REFERRAL_CODE_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "get_referral_code",
    };

    await axios
      .post(url, requestPayload)
      .then((res) => {
        dispatch({
          type: GET_REFERRAL_CODE_SUCCESS,
          payload: res?.data?.referral_code,
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getReferralCode(email, user, retryCount + 1),
          GET_REFERRAL_CODE_ERROR,
          user,
          email,
          formatTelegramLog("get_referral_code", requestPayload, url),
          0,
          currentPath,
        );
      });
  };

export const getReferralRewards =
  (email, user, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: GET_REFERRAL_REWARD_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      email,
      user,
      request_type: "get_referral_reward_list",
    };

    await axios
      .post(url, requestPayload)
      .then((res) => {
        dispatch({
          type: GET_REFERRAL_REWARD_SUCCESS,
          payload: res?.data,
        });
      })
      .catch((err) => {
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => getReferralRewards(email, user, retryCount + 1),
          GET_REFERRAL_REWARD_ERROR,
          user,
          email,
          formatTelegramLog("get_referral_reward_list", requestPayload, url),
          0,
          currentPath,
        );
      });
  };

export const chargeCreditWithCart =
  (
    user,
    email,
    amount,
    success_url = window.location.href,
    cancel_url = window.location.href,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: INCREASE_CREDIT_WITH_CARD_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      user,
      email,
      request_type: "get_one_off_stripe_checkout_session",
      amount,
      activation_mode: "increase_credit",
      success_url,
      cancel_url,
    };

    await axios
      .post(url, requestPayload)
      .then((res) => {
        console.log(res);
        dispatch({
          type: INCREASE_CREDIT_WITH_CARD_SUCCESS,
          payload: res?.data,
        });
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            chargeCreditWithCart(
              user,
              email,
              amount,
              success_url,
              cancel_url,
              retryCount + 1,
            ),
          INCREASE_CREDIT_WITH_CARD_ERROR,
          user,
          email,
          formatTelegramLog(
            "get_one_off_stripe_checkout_session/increase_credit",
            requestPayload,
            url,
          ),
          0,
          currentPath,
        );
      });
  };

export const chargeCreditWithCrypto =
  (
    user,
    email,
    amount,
    success_url = window.location.href,
    cancel_url = window.location.href,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: CHARGE_CREDIT_WITH_CRYPTO_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      user,
      email,
      request_type: "get_one_off_plisio_checkout_session",
      amount,
      activation_mode: "increase_credit",
      success_url,
      cancel_url,
    };

    await axios
      .post(url, requestPayload)
      .then((res) => {
        console.log(res);
        dispatch({
          type: CHARGE_CREDIT_WITH_CRYPTO_SUCCESS,
          payload: res?.data,
        });
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            chargeCreditWithCrypto(
              user,
              email,
              amount,
              success_url,
              cancel_url,
              retryCount + 1,
            ),
          CHARGE_CREDIT_WITH_CRYPTO_ERROR,
          user,
          email,
          formatTelegramLog(
            "get_one_off_plisio_checkout_session/increase_credit",
            requestPayload,
            url,
          ),
          0,
          currentPath,
        );
      });
  };

export const activateServiceWithCredit =
  (
    user,
    email,
    activation_mode,
    amount,
    success_url,
    cancel_url,
    showAlert = false,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: ACTIVATE_SERVICE_WITH_CREDIT_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      user,
      email,
      activation_mode,
      amount,
      success_url,
      cancel_url,
      platform_mode: "pricing_plan",
      request_type: "activate_service_using_credit",
    };

    await axios
      .post(url, requestPayload)
      .then((res) => {
        console.log(res);
        dispatch({
          type: ACTIVATE_SERVICE_WITH_CREDIT_SUCCESS,
          payload: res?.data,
        });

        if (showAlert) {
          alert(null, "Successfully activated.", "success", {
            cancel: "Ok",
          });
        }

        dispatch(getProfileData(email, user));
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            activateServiceWithCredit(
              user,
              email,
              activation_mode,
              amount,
              success_url,
              cancel_url,
              retryCount + 1,
            ),
          ACTIVATE_SERVICE_WITH_CREDIT_ERROR,
          user,
          email,
          formatTelegramLog(
            `activate_service_using_credit/${activation_mode}`,
            requestPayload,
            url,
          ),
          0,
          currentPath,
        );
      });
  };

export const activateServiceWithCrypto =
  (
    user,
    email,
    activation_mode,
    amount,
    success_url,
    cancel_url,
    signal = null,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: ACTIVATE_SERVICE_WITH_CRYPTO_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      user,
      email,
      activation_mode,
      amount,
      success_url,
      cancel_url,
      platform_mode: "pricing_plan",
      request_type: "get_one_off_plisio_checkout_session",
    };

    await axios
      .post(url, requestPayload, { signal })
      .then((res) => {
        console.log(res);
        dispatch({
          type: ACTIVATE_SERVICE_WITH_CRYPTO_SUCCESS,
          payload: res?.data,
        });
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            activateServiceWithCrypto(
              user,
              email,
              activation_mode,
              amount,
              success_url,
              cancel_url,
              signal,
              retryCount + 1,
            ),
          ACTIVATE_SERVICE_WITH_CRYPTO_ERROR,
          user,
          email,
          formatTelegramLog(
            `get_one_off_plisio_checkout_session/${activation_mode}`,
            requestPayload,
            url,
          ),
          0,
          currentPath,
        );
      });
  };

export const activateServiceWithCard =
  (
    user,
    email,
    activation_mode,
    amount,
    success_url,
    cancel_url,
    retryCount = 0,
    currentPath = window?.location?.href,
  ) =>
  async (dispatch) => {
    dispatch({ type: ACTIVATE_SERVICE_WITH_CREDIT_CARD_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      user,
      email,
      activation_mode,
      amount,
      success_url,
      cancel_url,
      platform_mode: "pricing_plan",
      request_type: "get_one_off_stripe_checkout_session",
    };

    await axios
      .post(url, requestPayload)
      .then((res) => {
        console.log(res);
        dispatch({
          type: ACTIVATE_SERVICE_WITH_CREDIT_CARD_SUCCESS,
          payload: res?.data,
        });
      })
      .catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () =>
            activateServiceWithCard(
              user,
              email,
              activation_mode,
              amount,
              success_url,
              cancel_url,
              retryCount + 1,
            ),
          ACTIVATE_SERVICE_WITH_CREDIT_CARD_ERROR,
          user,
          email,
          formatTelegramLog(
            `get_one_off_stripe_checkout_session/${activation_mode}`,
            requestPayload,
            url,
          ),
          0,
          currentPath,
        );
      });
  };

export const requestWithdraw =
  (email, user, amount, retryCount = 0, currentPath = window?.location?.href) =>
  async (dispatch) => {
    dispatch({ type: WITHDRAW_REQUEST });

    const url =
      "https://r7bphhzu5c.execute-api.us-east-1.amazonaws.com/dev/api";
    const requestPayload = {
      platform_mode: "pricing_plan",
      user,
      email,
      amount,
      request_type: "request_withdraw_cashble_reward",
    };

    await axios.post(url, requestPayload).then((res) => {
      console.log(res);
      dispatch({ type: WITHDRAW_SUCCESS, payload: res?.data?.message });
      alert(null, res?.data?.message, "success", {
        cancel: "Ok",
      }).catch((err) => {
        console.log(err);
        axiosErrorHandler(
          err,
          retryCount,
          dispatch,
          () => requestWithdraw(email, user, amount, retryCount + 1),
          WITHDRAW_ERROR,
          user,
          email,
          formatTelegramLog(
            "request_withdraw_cashble_reward",
            requestPayload,
            url,
          ),
          0,
          currentPath,
        );
      });
    });
  };

export const resetActivationWithCreditData = () => (dispatch) => {
  return dispatch({ type: "reset-activationWithCreditData" });
};

export const resetActivationWithCryptoData = () => (dispatch) => {
  return dispatch({ type: "reset-activationWithCryptoData" });
};

export const resetActivationWithCardData = () => (dispatch) => {
  return dispatch({ type: "reset-activationWithCardData" });
};

export const getPricingPlan = () => (dispatch) => {
  dispatch({ type: GET_PRICING_PLANS_REQUEST });

  fetch(
    "https://s3.ap-southeast-2.amazonaws.com/www.cryptocrispy.com.au/CryptoCrispyPricingPlan.json",
  )
    .then((res) => res.json())
    .then((data) => {
      // console.log(data);
      dispatch({
        type: GET_PRICING_PLANS_SUCCESS,
        payload: data,
      });
    })
    .catch((err) => {
      console.log(err);
      dispatch({ type: GET_PRICING_PLANS_ERROR });
    });
};
